<template>
    <a-modal
        :title="dataInfo.id ? this.$t('layout.edit') : $t('layout.add')"
        :visible="visible"
        :centered="true"
        :confirm-loading="confirmLoading"
        :bodyStyle="{ height: '80vh', overflow: 'auto' }"
        :width="800"
        @ok="handleOk"
        @cancel="handleCancel"
    >
        <a-form class="min-form-style" :form="form">
            <h2 class="type-title">{{ $t('goods.basic_info' /* 基本信息 */) }}</h2>
            <a-form-item :label="$t('store.goods_id')" style="display: none">
                <a-input v-decorator="['id', { rules: [{ required: false }] }]" />
            </a-form-item>
            <a-row style="height: auto" :gutter="[20, 0]" type="flex">
                <a-col :span="12">
                    <a-form-item :label="$t('store.goods_name')">
                        <a-input
                            style="width: 100%"
                            v-decorator="['name', { rules: [{ required: true, message: /*'请输入门票名称'*/ $t('layout.please_enter') + $t('store.goods_name') }] }]"
                            :placeholder="$t('layout.please_enter') + $t('store.goods_name')"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item :label="$t('store.goods_type')" style="">
                        <a-tree-select
                            v-decorator="['type_id', { rules: [{ required: true, message: /*'请选择门票类型'*/ $t('layout.please_select') + $t('store.goods_type') }] }]"
                            :placeholder="$t('layout.please_select') + $t('store.goods_type')"
                            show-search
                            style="width: 100%"
                            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                            allow-clear
                            tree-default-expand-all
                        >
                            <a-tree-select-node :key="item.id" :value="item.id" :title="item.name" v-for="(item, index) in typeList" :selectable="!item.children.length">
                                <a-tree-select-node v-for="(data, idx) in item.children" :key="data.id" :value="data.id" :title="data.name" :selectable="!data.children.length">
                                    <a-tree-select-node v-for="(d, i) in data.children" :key="d.id" :value="d.id" :title="d.name" :selectable="!d.children.length" />
                                </a-tree-select-node>
                            </a-tree-select-node>
                        </a-tree-select>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item :label="/*基础价格*/ $t('store.basic_price')">
                        <a-input-group compact>
                            <a-select
                                style="width: 35%"
                                v-decorator="['currency', { initialValue: '1', rules: [{ required: true, message: /*'请选择币种'*/ $t('layout.please_select') + $t('store.currency') }] }]"
                                :placeholder="$t('layout.please_select') + $t('store.currency')"
                            >
                                <a-select-option v-for="(item, index) in currencyList" :value="item.id" :key="index">{{ item.name }}</a-select-option>
                            </a-select>
                            <a-input-number
                                style="width: 65%"
                                :precision="2"
                                :min="0"
                                v-decorator="['price', { rules: [{ required: true, message: /*'请输入基础价格'*/ $t('layout.please_enter') + $t('store.basic_price') }] }]"
                                :placeholder="$t('layout.please_enter') + $t('store.basic_price')"
                            />
                        </a-input-group>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item :label="/*销售时段*/ $t('store.sales_period')">
                        <a-range-picker
                            style="width: 100%"
                            show-time
                            v-decorator="['sale_time', { rules: [{ required: true, message: /*'请选择销售时段'*/ $t('layout.please_select') + $t('store.sales_period') }] }]"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item :label="$t('store.unit') /* 单位 */">
                        <a-select
                            v-decorator="['unit', { initialValue: $t('goods.unit' /*张 */), rules: [{ required: true, message: $t('layout.please_select') + $t('store.unit') /** 请选择单位 **/ }] }]"
                            :placeholder="$t('layout.please_select') + $t('store.unit')"
                        >
                            <a-select value="张">{{ $t('goods.unit' /*张 */) }}</a-select>
                        </a-select>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item :label="/*单人持票数量*/ $t('store.per_capita_limit')">1{{ $t('goods.unit' /*张 */) }}</a-form-item>
                </a-col>
            </a-row>
            <h2 class="type-title mt15">{{ $t('goods.basic_config' /* 基本配置 */) }}</h2>
            <a-row :gutter="[20, 0]" type="flex">
                <a-col :xs="24" :sm="12">
                    <a-form-item :label="/*库存*/ $t('store.inventory')" :required="true">
                        <a-row>
                            <a-col :span="14">
                                <a-form-item>
                                    <a-radio-group
                                        v-decorator="[
                                            'is_limit',
                                            { initialValue: '0', rules: [{ required: true, message: /*'请选择是否限购'*/ $t('layout.please_select') + $t('store.is_limited') }] }
                                        ]"
                                        :placeholder="$t('layout.please_select') + $t('store.is_limited')"
                                    >
                                        <a-radio value="0">
                                            <!--无上限-->
                                            {{ $t('store.unlimited') }}
                                        </a-radio>
                                        <a-radio value="1">
                                            <!--限量库存-->
                                            {{ $t('store.limited_inventory') }}
                                        </a-radio>
                                    </a-radio-group>
                                </a-form-item>
                            </a-col>
                            <a-col :span="10">
                                <a-form-item>
                                    <a-input-number
                                        style="width: 100%"
                                        :precision="0"
                                        :min="0"
                                        :disabled="form.getFieldValue('is_limit') == 0"
                                        v-decorator="[
                                            'inventory',
                                            { rules: [{ required: form.getFieldValue('is_limit') == 1, message: /*'请输入库存总数'*/ $t('layout.please_enter') + $t('store.inventory_total') }] }
                                        ]"
                                        :placeholder="/*请输入正整数*/ $t('layout.please_enter') + $t('layout.positive_integer')"
                                    />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-form-item>
                </a-col>
                <a-col :xs="24" :sm="6">
                    <a-form-item :label="$t('store.min_num') /** 最少购买数量 **/">
                        <a-input-number
                            style="width: 100%"
                            :min="0"
                            v-decorator="['min_num', { initialValue: '1', rules: [{ required: true, message: $t('layout.please_enter') + $t('store.min_num') /** 请输入最少购买数量 **/ }] }]"
                            :placeholder="$t('layout.please_enter') + $t('store.min_num')"
                        ></a-input-number>
                    </a-form-item>
                </a-col>
                <a-col :xs="24" :sm="6">
                    <a-form-item :label="$t('store.max_num') /** 最多购买数量 **/">
                        <a-input-number
                            style="width: 100%"
                            :min="0"
                            v-decorator="['max_num', { initialValue: '1', rules: [{ required: true, message: $t('layout.please_enter') + $t('store.max_num') /** 请输入最多购买数量 **/ }] }]"
                            :placeholder="$t('layout.please_enter') + $t('store.max_num')"
                        ></a-input-number>
                    </a-form-item>
                </a-col>
                <a-col :xs="24" :sm="8">
                    <a-form-item :label="$t('store.goods_status')">
                        <a-radio-group
                            v-decorator="['status', { initialValue: '0', rules: [{ required: true, message: /*'请选择上架计划'*/ $t('layout.please_select') + $t('store.shelf_information') }] }]"
                            :placeholder="$t('layout.please_select') + $t('store.shelf_information')"
                        >
                            <a-radio value="0">
                                <!--下架-->
                                {{ $t('store.sold_out') }}
                            </a-radio>
                            <a-radio value="1">
                                <!--上架-->
                                {{ $t('store.put_away') }}
                            </a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
                <a-col :xs="24" :sm="8">
                    <a-form-item :label="$t('store.showSurplus') /** 是否显示剩余数量 **/">
                        <a-radio-group
                            v-decorator="[
                                'is_show_surplus',
                                { initialValue: '0', rules: [{ required: true, message: $t('layout.please_select') + $t('store.showSurplus') /** 请选择是否显示剩余数量 **/ }] }
                            ]"
                            :placeholder="$t('layout.please_select') + $t('store.showSurplus')"
                        >
                            <a-radio value="1">{{ $t('layout.yes') /** 是 **/ }}</a-radio>
                            <a-radio value="0">{{ $t('layout.no') /** 否 **/ }}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
                <a-col :xs="24" :sm="8">
                    <a-form-item :label="$t('store.showPrice') /** 是否显示金额 **/">
                        <a-radio-group
                            v-decorator="['is_show_price', { initialValue: '0', rules: [{ required: true, message: $t('layout.please_select') + $t('store.showPrice') /** 请选择是否显示金额 **/ }] }]"
                            :placeholder="$t('layout.please_select') + $t('store.showPrice')"
                        >
                            <a-radio value="1">{{ $t('layout.yes') /** 是 **/ }}</a-radio>
                            <a-radio value="0">{{ $t('layout.no') /** 否 **/ }}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item :label="$t('store.show_status') /** 门票公开设置 **/">
                        <a-radio-group
                            v-decorator="['show_status', { initialValue: '0', rules: [{ required: true, message: $t('layout.please_select') + $t('store.show_status') /** 请选择门票公开设置 **/ }] }]"
                            :placeholder="$t('layout.please_select') + $t('store.show_status')"
                        >
                            <a-radio value="0">{{ $t('store.show_status0') /** 全部隐藏 **/ }}</a-radio>
                            <!-- <a-radio value="1">{{$t('store.show_status1') /** 全渠道可见 **/}}</a-radio> -->
                            <a-radio value="2">{{ $t('store.show_status2') /** 用户中心可见 **/ }}</a-radio>
                            <a-radio value="3">{{ $t('store.show_status3') /** 独立渠道可见 **/ }}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
            </a-row>
            <h2 class="type-title mt15">{{ $t('goods.other_config' /* 其他配置 */) }}</h2>
            <a-form-item :label="$t('store.goods_brief')">
                <!--                        <a-textarea v-decorator="[ 'introduction', { rules: [ { required: false, message: /*'请输入门票简介'*/ $t('layout.please_enter') + $t('store.goods_brief') } ] } ]" :placeholder="$t('layout.please_enter') + $t('store.goods_brief')" />-->
                <tinymce-editor :height="250" v-decorator="['introduction']" :type="2"></tinymce-editor>
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<script>
import userApi from '@/request/apiList';
import tinymceEditor from '@/components/Tinymce/index.vue';
import pick from 'lodash.pick';
import moment from 'moment';
const fields = [
    'id',
    'name',
    'type_id',
    'introduction',
    'currency',
    'price',
    'sale_time',
    'is_limit',
    'inventory',
    'limit_num',
    'status',
    'start_time',
    'end_time',
    'is_show_surplus',
    'is_show_price',
    'min_num',
    'max_num',
    'show_status'
];
export default {
    name: 'GoodsEdit',
    components: { tinymceEditor },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        dataInfo: {
            type: Object,
            default: () => {}
        },
        typeList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            loading: false,
            confirmLoading: false,
            form: this.$form.createForm(this),
            // 文件请求头
            uploadHeaders: {},
            // 文件请求地址
            uploadImageUrl: userApi.uploadImage,
            loading_v1: false,
            currencyList: [] //货币类型列表
        };
    },
    created() {
        this.$watch('visible', val => {
            if (val) {
                // 防止表单未注册
                fields.forEach(v => this.form.getFieldDecorator(v));
            }
        });
        this.$watch('dataInfo', () => {
            this.form.setFieldsValue({ type_id: this.dataInfo.type_id });
            if (!this.dataInfo.id) return;
            this.dataInfo.sale_time = [moment(this.dataInfo.start_time), moment(this.dataInfo.end_time)];
            this.$nextTick(() => {
                this.dataInfo.limit_num = 1;
                this.form.setFieldsValue(pick(this.dataInfo, fields));
            });
        });
        this.getCurrencyType();
    },
    mounted() {
        this.uploadHeaders['meetingID'] = this.$route.params.meeting_id;
        this.uploadHeaders['mid'] = this.$route.params.meeting_id;
        this.uploadHeaders['auth'] = this.$storage.get('token');
    },
    methods: {
        getCurrencyType() {
            this.$request.get({ url: 'getCurrencyType' }).then(res => {
                let json = res.data;
                //{1:人民币,2:美元} => [{id:1,name:人民币}]
                let currencyList = [];
                for (let key in json) {
                    currencyList.push({ id: key, name: json[key] });
                }
                this.currencyList = currencyList;
            });
        },
        handleCancel() {
            this.close();
            this.$emit('close');
        },
        handleOk() {
            this.form.validateFields((errors, values) => {
                if (!errors) {
                    // 合并数据
                    let data = this.form.getFieldsValue();
                    // 时间格式化
                    data.start_time = data.sale_time[0].format('YYYY-MM-DD HH:mm:ss');
                    data.end_time = data.sale_time[1].format('YYYY-MM-DD HH:mm:ss');
                    delete data.sale_time;
                    data.limit_num = 1;
                    this.$request
                        .post({ url: 'setGoods', data })
                        .then(res => {
                            this.$message.success(
                                this.dataInfo.id ? /*'编辑成功'*/ this.$t('layout.edit') + this.$t('layout.success') : /*'新增成功'*/ this.$t('layout.add') + this.$t('layout.success')
                            );
                            this.close();
                            this.$emit('ok');
                        })
                        .catch(err => {
                            this.$message.error(this.dataInfo.id ? /*'编辑失败'*/ this.$t('layout.edit') + this.$t('layout.fail') : /*'新增失败'*/ this.$t('layout.edit') + this.$t('layout.fail'));
                        });
                } else {
                    this.form.validateFieldsAndScroll();
                }
            });
        },
        close() {
            this.form.resetFields();
        }
    }
};
</script>

<style scoped lang="less">
.upload-form-item {
    /deep/.ant-form-item-children {
        .avatar-uploader {
            width: auto;
        }
        display: flex;
        align-items: flex-end;
        .ant-upload {
            margin-bottom: 0;
        }
    }
}

/deep/ .slick-list {
    overflow: visible;
}
</style>
